module.exports = __webpack_public_path__ + "static/media/ATC.3438d4c3.png";